async function loadPdfExportLibraries() {
  if (window.jspdf?.jsPDF && window.svg2pdf) return;

  const [jspdf, svg2pdf] = await Promise.all([
    import('jspdf'),
    import('svg2pdf.js')
  ]);

  window.jspdf = jspdf;
  window.svg2pdf = svg2pdf.svg2pdf;
}

export default loadPdfExportLibraries;
